import { Controller } from "@hotwired/stimulus"

// PΔ.301.3 — блок «отправить себе / поделиться»: почта через API контактов,
// нажатие WhatsApp фиксируем как намерение (номер узнаем из его сообщения),
// «скопировать ссылку».
export default class extends Controller {
  static targets = ["email", "button", "ok", "error", "copied"]
  static values = { endpoint: String }

  async email(event) {
    event.preventDefault()
    const value = this.emailTarget.value.trim()
    if (!value) return
    this.buttonTarget.disabled = true
    this.okTarget.classList.add("hidden")
    this.errorTarget.classList.add("hidden")
    const ok = await this.post({ kind: "email", value })
    this.buttonTarget.disabled = false
    ;(ok ? this.okTarget : this.errorTarget).classList.remove("hidden")
    if (ok) this.emailTarget.value = ""
  }

  whatsapp() {
    // не мешаем переходу по ссылке — просто отмечаем факт
    this.post({ kind: "whatsapp", value: "intent" })
  }

  async copy(event) {
    const url = event.params.url
    try {
      await navigator.clipboard.writeText(url)
      this.copiedTarget.classList.remove("hidden")
      setTimeout(() => this.copiedTarget.classList.add("hidden"), 2000)
    } catch (_) {
      window.prompt("", url)
    }
  }

  async post(body) {
    try {
      const resp = await fetch(this.endpointValue, {
        method: "POST",
        keepalive: true,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")?.content || ""
        },
        // PΔ.301.8 — язык страницы (переключатель отчёта) → сообщение/письмо на нём же
        body: JSON.stringify({ locale: document.documentElement.lang, ...body })
      })
      return resp.ok
    } catch (_) {
      return false
    }
  }
}
